import { Component, Inject, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import moment from 'moment';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'app-carousel-mini-card',
  templateUrl: './carousel-mini-card.component.html',
  styleUrls: ['./carousel-mini-card.component.scss'],
})
export class CarouselMiniCardComponent implements OnInit {
  @Input() data: any = [];
  imgUrl = environment.ImageUrl;
  options = {};
  constructor(
    @Inject("WINDOW") private window: any,
    private commonService: CommonService
  ) {
    this.setSwiperOptions(this.window.innerWidth);
  }
  setSwiperOptions(width: number) {
    if (width > 991) {
      this.options = {
        spaceBetween: 10,
        grid: {
          rows: 5,
          fill: 'row',
        },
      };
    } else {
      this.options = {
        spaceBetween: 10,
        slidesPerView: 1,
      };
    }
  }
  ngOnInit(): void {
    this.data = this.data.filter((item: any) => item.title != null);
  }
  formatText(text: string, length): string {
    // return text
    return text?.length > length ? text.substr(0, length) + '...' : text;
  }
  convertDate(value: number) {
    return moment.unix(value).format('MMMM D, YYYY');
  }
}
